import React from "react";
// Components
import Navibar from "../Navibar";

const Header = (props) => {
  return (
    <header>
      <Navibar />
    </header>
  );
};

export default Header;
